import RenderHTML from '../ui-components/RenderHTML'
import { CalendarSelection } from '../../types/calendar.types'
import { getFrequencyText } from '../../utils/mf-execution/calendar'

interface CalendarButtonProps {
  selection: CalendarSelection
}

export const CalendarButton: React.FC<CalendarButtonProps> = ({ selection }) => {
  return (
    <div className='rounded-[12px] gap-1 border border-[#EBF2F2] px-3 h-9 flex items-center justify-center text-[13px] text-[#232323] font-[500] animate-fade-150'>
      <div>{getFrequencyText(selection)}</div>
      <div className='pt-[1px]'>
        <RenderHTML innerHTMLText={DownCaretIcon} />
      </div>
    </div>
  )
}

const DownCaretIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M7.94028 9.66124L12.0321 5.295C12.1037 5.2185 12.1598 5.12843 12.1972 5.02993C12.2345 4.93142 12.2524 4.82642 12.2497 4.7209C12.2471 4.61539 12.224 4.51143 12.1818 4.41497C12.1396 4.31851 12.0791 4.23144 12.0037 4.15871C11.8515 4.01185 11.6481 3.93237 11.4381 3.93776C11.2282 3.94315 11.029 4.03297 10.8843 4.18747L7.18592 8.14051C7.1615 8.16674 7.13207 8.18764 7.09941 8.20193C7.06676 8.21621 7.03158 8.22358 6.99602 8.22358C6.96046 8.22358 6.92528 8.21621 6.89263 8.20193C6.85998 8.18764 6.83054 8.16674 6.80612 8.14051L3.10778 4.18747C2.96406 4.03382 2.76609 3.94442 2.55743 3.93892C2.34877 3.93343 2.1465 4.0123 1.99513 4.15818C1.84376 4.30406 1.75568 4.505 1.75026 4.7168C1.74485 4.92859 1.82255 5.1339 1.96628 5.28755L6.06855 9.67189C6.19175 9.79664 6.33808 9.89538 6.49908 9.96242C6.66009 10.0295 6.83258 10.0635 7.0066 10.0625C7.18062 10.0615 7.35273 10.0255 7.51298 9.95665C7.67323 9.88779 7.81846 9.78738 7.94028 9.66124Z" fill="#232323" stroke="#232323" stroke-width="0.25"/>
</svg>`
